export default __webpack_public_path__ + "assets/img_why_della8_banner-d0873a5e.png";